import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dfa2fd9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content-wrapper" }
const _hoisted_2 = { class: "distribution-groups-title grid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title col-3 mt-3" }, "タグ付配信グループ一覧", -1))
const _hoisted_4 = { class: "d-flex" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-full py-2" }, "※配信者数が20名以上でないとデータ取得ができません。", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page-title" }, "対象の絞り込み", -1))
const _hoisted_7 = { class: "d-flex mb-2" }
const _hoisted_8 = { class: "col-8 d-flex justify-content-start p-0" }
const _hoisted_9 = { class: "col-4 d-flex justify-content-start align-items-baseline date-picker-container" }
const _hoisted_10 = { class: "date-picker-input" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3 mr-2" }, "～", -1))
const _hoisted_12 = { class: "date-picker-input ml-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "page-title" }, "その他で絞り込み", -1))
const _hoisted_14 = { class: "d-flex mb-6" }
const _hoisted_15 = { class: "col-8 d-flex justify-content-start p-0" }
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex w-100 tagged-summary tagged-summary-label\" data-v-3dfa2fd9><div class=\"d-flex p-0\" data-v-3dfa2fd9><div class=\"d-flex tagged-summary-content\" data-v-3dfa2fd9><div class=\"d-flex flex-column w-100\" data-v-3dfa2fd9><span class=\"title_rate\" data-v-3dfa2fd9>対象グループ数</span></div></div></div><div class=\"d-flex p-0\" data-v-3dfa2fd9><div class=\"d-flex tagged-summary-content\" data-v-3dfa2fd9><div class=\"d-flex flex-column w-100\" data-v-3dfa2fd9><span class=\"title_rate\" data-v-3dfa2fd9>友だち数</span></div></div></div><div class=\"d-flex p-0\" data-v-3dfa2fd9><div class=\"d-flex tagged-summary-content\" data-v-3dfa2fd9><div class=\"d-flex flex-column w-100\" data-v-3dfa2fd9><span class=\"title_rate\" data-v-3dfa2fd9>メッセージ配信数</span></div></div></div><div class=\"d-flex p-0\" data-v-3dfa2fd9><div class=\"d-flex tagged-summary-content\" data-v-3dfa2fd9><div class=\"d-flex flex-column w-100\" data-v-3dfa2fd9><span class=\"title_rate\" data-v-3dfa2fd9>開封数</span></div></div></div><div class=\"d-flex p-0\" data-v-3dfa2fd9><div class=\"d-flex tagged-summary-content\" data-v-3dfa2fd9><div class=\"d-flex flex-column w-100\" data-v-3dfa2fd9><span class=\"title_rate\" data-v-3dfa2fd9>クリック数</span></div></div></div><div class=\"d-flex p-0\" data-v-3dfa2fd9><div class=\"d-flex tagged-summary-content\" data-v-3dfa2fd9><div class=\"d-flex flex-column w-100\" data-v-3dfa2fd9><span class=\"title_rate\" data-v-3dfa2fd9>予約完了数</span></div></div></div><div class=\"d-flex p-0\" data-v-3dfa2fd9><div class=\"d-flex tagged-summary-content\" data-v-3dfa2fd9><div class=\"d-flex flex-column w-100\" data-v-3dfa2fd9><span class=\"title_rate\" data-v-3dfa2fd9>予約キャンセル数</span></div></div></div></div>", 1)
const _hoisted_17 = { class: "d-flex w-100 tagged-summary" }
const _hoisted_18 = { class: "d-flex p-0" }
const _hoisted_19 = { class: "d-flex tagged-summary-content" }
const _hoisted_20 = { class: "d-flex flex-column w-100" }
const _hoisted_21 = { class: "d-flex" }
const _hoisted_22 = { class: "block_rate col-2 w-100" }
const _hoisted_23 = { class: "number_rate" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_25 = { class: "d-flex p-0" }
const _hoisted_26 = { class: "d-flex tagged-summary-content" }
const _hoisted_27 = { class: "d-flex flex-column w-100" }
const _hoisted_28 = { class: "d-flex" }
const _hoisted_29 = { class: "block_rate col-2 w-100" }
const _hoisted_30 = { class: "number_rate" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_32 = { class: "d-flex p-0" }
const _hoisted_33 = { class: "d-flex tagged-summary-content" }
const _hoisted_34 = { class: "d-flex flex-column w-100" }
const _hoisted_35 = { class: "d-flex" }
const _hoisted_36 = { class: "block_rate col-2 w-100" }
const _hoisted_37 = { class: "number_rate" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_39 = { class: "d-flex p-0" }
const _hoisted_40 = { class: "d-flex tagged-summary-content" }
const _hoisted_41 = { class: "d-flex flex-column w-100" }
const _hoisted_42 = { class: "d-flex" }
const _hoisted_43 = { class: "block_rate col-2 w-100" }
const _hoisted_44 = { class: "number_rate" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_46 = { class: "d-flex p-0" }
const _hoisted_47 = { class: "d-flex tagged-summary-content" }
const _hoisted_48 = { class: "d-flex flex-column w-100" }
const _hoisted_49 = { class: "d-flex" }
const _hoisted_50 = { class: "block_rate col-2 w-100" }
const _hoisted_51 = { class: "number_rate" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_53 = { class: "d-flex p-0" }
const _hoisted_54 = { class: "d-flex tagged-summary-content" }
const _hoisted_55 = { class: "d-flex flex-column w-100" }
const _hoisted_56 = { class: "d-flex" }
const _hoisted_57 = { class: "block_rate col-2 w-100" }
const _hoisted_58 = { class: "number_rate" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "arrow" }, null, -1))
const _hoisted_60 = { class: "d-flex p-0" }
const _hoisted_61 = { class: "d-flex tagged-summary-content" }
const _hoisted_62 = { class: "d-flex flex-column w-100" }
const _hoisted_63 = { class: "d-flex" }
const _hoisted_64 = { class: "block_rate col-2 w-100" }
const _hoisted_65 = { class: "number_rate" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "w-40px" }, null, -1))
const _hoisted_67 = { class: "d-flex w-100 tagged-summary" }
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex p-0\" data-v-3dfa2fd9><div class=\"d-flex tagged-summary-content\" data-v-3dfa2fd9><div class=\"d-flex flex-column w-100\" data-v-3dfa2fd9><div class=\"d-flex\" data-v-3dfa2fd9><div class=\"block_rate col-2 w-100 disable-block\" data-v-3dfa2fd9><div class=\"number_rate\" data-v-3dfa2fd9></div></div></div></div><div data-v-3dfa2fd9></div></div></div>", 1)
const _hoisted_69 = { class: "d-flex p-0" }
const _hoisted_70 = { class: "d-flex tagged-summary-content" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column w-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "block_rate col-2 w-100 disable-block" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "number_rate" })
    ])
  ])
], -1))
const _hoisted_72 = { class: "flex flex-column align-items-center" }
const _hoisted_73 = { class: "description-btn" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description-text mt-2 first-description" }, "送信率", -1))
const _hoisted_75 = { class: "d-flex p-0" }
const _hoisted_76 = { class: "d-flex tagged-summary-content" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column w-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "block_rate col-2 w-100 disable-block" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "number_rate" })
    ])
  ])
], -1))
const _hoisted_78 = { class: "flex flex-column align-items-center" }
const _hoisted_79 = { class: "description-btn" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description-text mt-2 second-description" }, "開封率", -1))
const _hoisted_81 = { class: "d-flex p-0" }
const _hoisted_82 = { class: "d-flex tagged-summary-content" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column w-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "block_rate col-2 w-100 disable-block" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "number_rate" })
    ])
  ])
], -1))
const _hoisted_84 = { class: "flex flex-column align-items-center" }
const _hoisted_85 = { class: "description-btn" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "description-text mt-2 third-description" }, "クリック率", -1))
const _hoisted_87 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex p-0\" data-v-3dfa2fd9><div class=\"d-flex tagged-summary-content\" data-v-3dfa2fd9><div class=\"d-flex flex-column w-100\" data-v-3dfa2fd9><div class=\"d-flex\" data-v-3dfa2fd9><div class=\"block_rate col-2 w-100 disable-block\" data-v-3dfa2fd9><div class=\"number_rate\" data-v-3dfa2fd9></div></div></div></div><div data-v-3dfa2fd9></div></div></div>", 1)
const _hoisted_88 = { class: "d-flex p-0" }
const _hoisted_89 = { class: "d-flex tagged-summary-content" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column w-100" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "block_rate col-2 w-100 disable-block" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "number_rate" })
    ])
  ])
], -1))
const _hoisted_91 = { class: "flex flex-column align-items-center" }
const _hoisted_92 = { class: "description-btn" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mt-2 fourth-description fourth-description-text" }, "キャンセル割合", -1))
const _hoisted_94 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex p-0\" data-v-3dfa2fd9><div class=\"d-flex tagged-summary-content\" data-v-3dfa2fd9><div class=\"d-flex flex-column w-100\" data-v-3dfa2fd9><div class=\"d-flex\" data-v-3dfa2fd9><div class=\"block_rate col-2 w-100 disable-block\" data-v-3dfa2fd9><div class=\"number_rate\" data-v-3dfa2fd9></div></div></div></div><div class=\"w-40px\" data-v-3dfa2fd9></div></div></div>", 1)
const _hoisted_95 = { class: "d-flex mt-7" }
const _hoisted_96 = { class: "col-6" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "page-title chart-description" }, "開封率順グラフ")
], -1))
const _hoisted_98 = {
  key: 0,
  class: "horizontal-bar-chart mt-4"
}
const _hoisted_99 = {
  key: 1,
  class: "no-data-container mt-4"
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-data" }, "データが存在しません。", -1))
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = { class: "col-6" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "page-title chart-description" }, "クリック率順グラフ")
], -1))
const _hoisted_104 = {
  key: 0,
  class: "horizontal-bar-chart mt-4"
}
const _hoisted_105 = {
  key: 1,
  class: "no-data-container mt-4"
}
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-data" }, "データが存在しません。", -1))
const _hoisted_107 = [
  _hoisted_106
]
const _hoisted_108 = { class: "d-flex mt-7" }
const _hoisted_109 = { class: "col-6" }
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "page-title chart-description" }, "未開封率順グラフ")
], -1))
const _hoisted_111 = {
  key: 0,
  class: "horizontal-bar-chart mt-4 mb-3"
}
const _hoisted_112 = {
  key: 1,
  class: "no-data-container mt-4"
}
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-data" }, "データが存在しません。", -1))
const _hoisted_114 = [
  _hoisted_113
]
const _hoisted_115 = { class: "col-6" }
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "page-title chart-description" }, "予約完了率順グラフ")
], -1))
const _hoisted_117 = {
  key: 0,
  class: "horizontal-bar-chart mt-4 mb-3"
}
const _hoisted_118 = {
  key: 1,
  class: "no-data-container mt-4"
}
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-data" }, "データが存在しません。", -1))
const _hoisted_120 = [
  _hoisted_119
]

import { ref, onBeforeMount } from "vue";
import { get, set } from "@vueuse/core";
import VChart from "vue-echarts";
import Calendar from "primevue/calendar";
import { BarChart } from "echarts/charts";
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent, DatasetComponent } from "echarts/components";
import { useStore } from "vuex";
import DistributionGroupService from "@/clinic/services/distribution_group_service";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";
import { notityErrorMsg } from "@/clinic/utils/notify-utils";
import RouterConstants from "@/clinic/constants/router.constants";
import RouterUtils from "@/common/utils/router.util";


export default /*#__PURE__*/_defineComponent({
  __name: 'TaggedDeliverySummary',
  setup(__props) {

use([CanvasRenderer, BarChart, GridComponent, DatasetComponent, TitleComponent, TooltipComponent, LegendComponent]);

const toast = useToast();
const store = useStore();
const date = new Date();
const clinicId = ref("");
const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
const period_start = ref(firstDay);
const period_end = ref(lastDay);
const selectedCategory = ref("");
const totalGroups = ref(0);
const totalFriends = ref(0);
const totalDelivered = ref(0);
const totalSendedRate = ref(0);
const totalCancelRate = ref(0);
const totalOpenedRate = ref(0);
const totalClickRate = ref(0);
const totalOpens = ref(0);
const totalClicks = ref(0);
const totalCompletedReservations = ref(0);
const totalReservationCancellations = ref(0);
const topOpenedRate = ref([]);
const topUnopenedRate = ref([]);
const topCompletedReservationsRate = ref([]);
const topClickRate = ref([]);
const openedChartResources = ref([]);
const openedChartData = ref([]);
const unOpenedChartResources = ref([]);
const unOpenedChartData = ref([]);
const clickChartResources = ref([]);
const clickChartData = ref([]);
const bookingRateChartOptions = ref([]);
const bookingRateChartData = ref([]);
const chartType = ref("topFive");

const chartOptions = (resources, data) => {
  const reversedResources = resources.slice().reverse();
  const reversedData = data.slice().reverse();

  return {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: "{b}: {c}%",
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      max: 100,
      axisLabel: {
        formatter: "{value}%",
      },
    },
    yAxis: {
      type: "category",
      data: reversedResources,
    },
    series: [
      {
        name: "Value",
        type: "bar",
        data: reversedData, // Convert data to percentage
        label: {
          show: true,
          position: "insideRight",
          formatter: "{c}%",
          color: "#747474",
        },
        itemStyle: {
          color: "#747474",
        },
      },
    ],
  };
};

const bookRateChartOptions = ref();
const unOpenedChartOptions = ref();
const openedChartOptions = ref();
const clickChartOptions = ref();

const goToNewDistributionGroup = () => {
  RouterUtils.goTo(RouterConstants.NEW_DISTRIBUTION_GROUPS_NAME);
};
const goToGroupDraft = () => {
  RouterUtils.goTo(RouterConstants.DISTRIBUTION_GROUPS_DRAFTS_NAME);
};
const goToGroupLists = () => {
  RouterUtils.goTo(RouterConstants.DISTRIBUTION_GROUP_ROUTER_NAME);
};

const loadClinicInfo = async () => {
  const storeClinicId = await store.dispatch("authClient/getClinicIdCookie");
  clinicId.value = storeClinicId;
};

const handleError = promise => {
  return promise.then(data => [undefined, data]).catch(error => [error, undefined]);
};

const changeDate = async event => {
  resetValue();
  const params = initParams(period_start.value, period_end.value);
  await fetchDistributionGroups(params);
};

const initParams = (period_start, period_end) => {
  return {
    clinic_id: clinicId.value,
    send_at_start: period_start,
    send_at_end: period_end,
    group_type: selectedCategory.value,
    order_by: "created_at",
    order: "desc",
  };
};

const fetchDistributionGroups = async params => {
  const [error, response] = await handleError(DistributionGroupService.getDistributionGroups(params));
  if (error) {
    notityErrorMsg(toast, "分析の取得中にエラーが発生しました。後でもう一度試してください");
    return;
  }
  analyticsResponse(response.data.value);
};

const selectCategoryType = async categoryType => {
  resetValue();
  if (categoryType == 6) {
    const date = new Date();
    selectedCategory.value = "";
    const firstDayLastMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);
    const lastDayLastMonth = new Date(date.getFullYear(), date.getMonth(), 0);
    const params = initParams(firstDayLastMonth, lastDayLastMonth);
    await fetchDistributionGroups(params);
    selectedCategory.value = 6;
  } else {
    selectedCategory.value = categoryType;
    const params = initParams(period_start.value, period_end.value);
    await fetchDistributionGroups(params);
  }
};

const resetValue = () => {
  totalGroups.value = 0;
  totalFriends.value = 0;
  totalDelivered.value = 0;
  totalOpens.value = 0;
  totalClicks.value = 0;
  totalCompletedReservations.value = 0;
  totalReservationCancellations.value = 0;
  topOpenedRate.value = [];
  topUnopenedRate.value = [];
  topCompletedReservationsRate.value = [];
  topClickRate.value = [];
  openedChartResources.value = [];
  openedChartData.value = [];
  unOpenedChartResources.value = [];
  unOpenedChartData.value = [];
  clickChartResources.value = [];
  clickChartData.value = [];
  bookingRateChartOptions.value = [];
  bookingRateChartData.value = [];
};

const calculateRate = (numerator, denominator) => {
  if (denominator.value == 0) {
    return 0;
  } else {
    return ((Number.parseFloat(numerator.value) / denominator.value) * 100).toFixed(2);
  }
};

const selectChartType = async type => {
  resetValue();
  set(chartType, type);
  const params = initParams(period_start.value, period_end.value);
  await fetchDistributionGroups(params);
};

const analyticsResponse = response => {
  totalGroups.value = response.meta.total_count;
  const campaigns = response.distribution_groups;
  campaigns.forEach(campaign => {
    if (campaign.number_of_friends !== null) totalFriends.value += campaign.number_of_friends;
    if (campaign.number_of_delivered !== null) totalDelivered.value += campaign.number_of_delivered;
    if (campaign.number_of_opens !== null) totalOpens.value += campaign.number_of_opens;
    if (campaign.number_of_clicks !== null) totalClicks.value += campaign.number_of_clicks;
    if (campaign.number_of_completed_reservations !== null)
      totalCompletedReservations.value += campaign.number_of_completed_reservations;
    if (campaign.number_of_reservation_cancellations !== null)
      totalReservationCancellations.value += campaign.number_of_reservation_cancellations;
  });

  totalSendedRate.value = calculateRate(totalDelivered, totalFriends);
  totalClickRate.value = calculateRate(totalClicks, totalOpens);
  totalCancelRate.value = calculateRate(totalReservationCancellations, totalCompletedReservations);
  totalOpenedRate.value = calculateRate(totalOpens, totalDelivered);

  const sortByOpenedRate = (a, b) => {
    return get(chartType) == "topNewest" ? b.created_at - a.created_at : b.opened_rate - a.opened_rate;
  };

  const sortByUnopenedRate = (a, b) => {
    return get(chartType) == "topNewest" ? b.created_at - a.created_at : b.unopened_rate - a.unopened_rate;
  };

  const sortByCompletedReservationsRate = (a, b) => {
    return get(chartType) == "topNewest"
      ? b.created_at - a.created_at
      : b.completed_reservations_rate - a.completed_reservations_rate;
  };

  const sortByClickRate = (a, b) => {
    return get(chartType) == "topNewest" ? b.created_at - a.created_at : b.click_rate - a.click_rate;
  };

  topOpenedRate.value = campaigns
    .filter(campaign => campaign.opened_rate !== null && campaign.opened_rate !== 0)
    .sort(sortByOpenedRate)
    .slice(0, 5);

  const openedChartResources = topOpenedRate.value.map(value => value.name);
  openedChartData.value = topOpenedRate.value.map(value => value.opened_rate);
  openedChartOptions.value = chartOptions(openedChartResources, openedChartData.value);

  // extract unopened rate
  topUnopenedRate.value = campaigns
    .filter(campaign => campaign.unopened_rate !== null && campaign.unopened_rate !== 0)
    .sort(sortByUnopenedRate)
    .slice(0, 5);

  const unOpenedChartResources = topUnopenedRate.value.map(value => value.name);
  unOpenedChartData.value = topUnopenedRate.value.map(value => value.unopened_rate);
  unOpenedChartOptions.value = chartOptions(unOpenedChartResources, unOpenedChartData.value);

  // extract complete reservation rate
  topCompletedReservationsRate.value = campaigns
    .filter(campaign => campaign.completed_reservations_rate != null && campaign.completed_reservations_rate != 0)
    .sort(sortByCompletedReservationsRate)
    .slice(0, 5);

  const bookingRateResources = topCompletedReservationsRate.value.map(value => value.name);
  bookingRateChartData.value = topCompletedReservationsRate.value.map(value => value.completed_reservations_rate);
  bookRateChartOptions.value = chartOptions(bookingRateResources, bookingRateChartData.value);

  // extract click rate
  topClickRate.value = campaigns
    .filter(campaign => campaign.click_rate !== null && campaign.click_rate !== 0)
    .sort(sortByClickRate)
    .slice(0, 5);

  const clickRateResources = topClickRate.value.map(value => value.name);
  clickChartData.value = topClickRate.value.map(value => value.click_rate);
  clickChartOptions.value = chartOptions(clickRateResources, clickChartData.value);
};

onBeforeMount(async () => {
  await loadClinicInfo();
  const params = initParams(period_start.value, period_end.value);
  await fetchDistributionGroups(params);
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_Button, {
            class: "col-auto mr-3 distribution-group-btn mt-3",
            label: "配信グループ一覧",
            onClick: goToGroupLists
          }),
          _createVNode(_component_Button, {
            class: "col-auto mr-3 temp-save-btn mt-3",
            label: "下書保存を再編集",
            onClick: goToGroupDraft
          }),
          _createVNode(_component_Button, {
            class: "col-auto mt-3 create-btn mb-2",
            label: "配信グループ新規作成",
            onClick: goToNewDistributionGroup
          })
        ])
      ]),
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            label: "すべて",
            class: _normalizeClass(["mr-2 target-button", { 'bg-custom': !selectedCategory.value }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (selectCategoryType('')))
          }, null, 8, ["class"]),
          _createVNode(_component_Button, {
            label: "直近1ヶ月",
            class: _normalizeClass(["mr-2 target-button", { 'bg-custom': selectedCategory.value === 6 }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (selectCategoryType(6)))
          }, null, 8, ["class"]),
          _createVNode(_component_Button, {
            label: "新規向け",
            class: _normalizeClass(["mr-2 target-button", { 'bg-custom': selectedCategory.value === 1 }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (selectCategoryType(1)))
          }, null, 8, ["class"]),
          _createVNode(_component_Button, {
            label: "再来向け",
            class: _normalizeClass(["mr-2 target-button", { 'bg-custom': selectedCategory.value === 2 }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (selectCategoryType(2)))
          }, null, 8, ["class"]),
          _createVNode(_component_Button, {
            label: "既存向け",
            class: _normalizeClass(["mr-2 target-button", { 'bg-custom': selectedCategory.value === 3 }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (selectCategoryType(3)))
          }, null, 8, ["class"]),
          _createVNode(_component_Button, {
            label: "一斉配信",
            class: _normalizeClass(["mr-2 target-button", { 'bg-custom': selectedCategory.value === 4 }]),
            onClick: _cache[5] || (_cache[5] = ($event: any) => (selectCategoryType(4)))
          }, null, 8, ["class"]),
          _createVNode(_component_Button, {
            label: "その他",
            class: _normalizeClass(["mr-2 target-button", { 'bg-custom': selectedCategory.value === 5 }]),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (selectCategoryType(5)))
          }, null, 8, ["class"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(Calendar), {
              id: "birthday",
              modelValue: period_start.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((period_start).value = $event)),
              "aria-describedby": "birthday-help",
              type: "date",
              size: "large",
              showIcon: "",
              placeholder: "yyyy/mm/dd",
              dateFormat: "yy/mm/dd",
              onDateSelect: _cache[8] || (_cache[8] = ($event: any) => (changeDate($event)))
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_unref(Calendar), {
              id: "birthday",
              modelValue: period_end.value,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((period_end).value = $event)),
              "aria-describedby": "birthday-help",
              type: "date",
              showIcon: "",
              size: "large",
              placeholder: "yyyy/mm/dd",
              dateFormat: "yy/mm/dd",
              onDateSelect: _cache[10] || (_cache[10] = ($event: any) => (changeDate($event)))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_Button, {
            label: "効果高い順",
            class: _normalizeClass(["mr-2 target-button", { 'bg-custom': chartType.value === 'topFive' }]),
            onClick: _cache[11] || (_cache[11] = ($event: any) => (selectChartType('topFive')))
          }, null, 8, ["class"]),
          _createVNode(_component_Button, {
            label: "最新順",
            class: _normalizeClass(["mr-2 target-button", { 'bg-custom': chartType.value === 'topNewest' }]),
            onClick: _cache[12] || (_cache[12] = ($event: any) => (selectChartType('topNewest')))
          }, null, 8, ["class"])
        ])
      ]),
      _hoisted_16,
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(totalGroups.value), 1)
                ])
              ])
            ]),
            _hoisted_24
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, _toDisplayString(totalFriends.value), 1)
                ])
              ])
            ]),
            _hoisted_31
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, _toDisplayString(totalDelivered.value), 1)
                ])
              ])
            ]),
            _hoisted_38
          ])
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, _toDisplayString(totalOpens.value), 1)
                ])
              ])
            ]),
            _hoisted_45
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, _toDisplayString(totalClicks.value), 1)
                ])
              ])
            ]),
            _hoisted_52
          ])
        ]),
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, [
                _createElementVNode("div", _hoisted_57, [
                  _createElementVNode("div", _hoisted_58, _toDisplayString(totalCompletedReservations.value), 1)
                ])
              ])
            ]),
            _hoisted_59
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, _toDisplayString(totalReservationCancellations.value), 1)
                ])
              ])
            ]),
            _hoisted_66
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_67, [
        _hoisted_68,
        _createElementVNode("div", _hoisted_69, [
          _createElementVNode("div", _hoisted_70, [
            _hoisted_71,
            _createElementVNode("div", _hoisted_72, [
              _createElementVNode("div", _hoisted_73, _toDisplayString(totalSendedRate.value) + "%", 1),
              _hoisted_74
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_75, [
          _createElementVNode("div", _hoisted_76, [
            _hoisted_77,
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, _toDisplayString(totalOpenedRate.value) + "%", 1),
              _hoisted_80
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("div", _hoisted_82, [
            _hoisted_83,
            _createElementVNode("div", _hoisted_84, [
              _createElementVNode("div", _hoisted_85, _toDisplayString(totalClickRate.value) + "%", 1),
              _hoisted_86
            ])
          ])
        ]),
        _hoisted_87,
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _hoisted_90,
            _createElementVNode("div", _hoisted_91, [
              _createElementVNode("div", _hoisted_92, _toDisplayString(totalCancelRate.value) + "%", 1),
              _hoisted_93
            ])
          ])
        ]),
        _hoisted_94
      ]),
      _createElementVNode("div", _hoisted_95, [
        _createElementVNode("div", _hoisted_96, [
          _hoisted_97,
          (openedChartData.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                _createVNode(_unref(VChart), {
                  ref: "bar",
                  option: openedChartOptions.value,
                  class: "chart",
                  autoresize: ""
                }, null, 8, ["option"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_99, _hoisted_101))
        ]),
        _createElementVNode("div", _hoisted_102, [
          _hoisted_103,
          (clickChartData.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                _createVNode(_unref(VChart), {
                  ref: "bar",
                  option: clickChartOptions.value,
                  class: "chart",
                  autoresize: ""
                }, null, 8, ["option"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_105, _hoisted_107))
        ])
      ]),
      _createElementVNode("div", _hoisted_108, [
        _createElementVNode("div", _hoisted_109, [
          _hoisted_110,
          (unOpenedChartData.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_111, [
                _createVNode(_unref(VChart), {
                  ref: "bar",
                  option: unOpenedChartOptions.value,
                  class: "chart",
                  autoresize: ""
                }, null, 8, ["option"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_112, _hoisted_114))
        ]),
        _createElementVNode("div", _hoisted_115, [
          _hoisted_116,
          (bookingRateChartData.value.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                _createVNode(_unref(VChart), {
                  ref: "bar",
                  option: bookRateChartOptions.value,
                  class: "chart",
                  autoresize: ""
                }, null, 8, ["option"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_118, _hoisted_120))
        ])
      ])
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ], 64))
}
}

})